// extracted by mini-css-extract-plugin
export default {"showcase":"video_showcase__4JiL+","overlay":"video_overlay__5r9eh","text":"video_text__63xBX"};